import {BaseQueryFn, FetchArgs, fetchBaseQuery,} from '@reduxjs/toolkit/query/react';
import {createApi} from '@reduxjs/toolkit/dist/query/react';
import {FetchBaseQueryError} from '@reduxjs/toolkit/query';
// import { HandleError } from '@/hooks';
import {logout, update} from "./slice/auth.slice";

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API}/api/v1/`,
  credentials: "include"
});

const AuthQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions = {}) => {
  let response = await baseQuery(args, api, extraOptions);
  if (
    response?.error &&
    response?.error?.status === 401
  ) {
    const {data, error} = await baseQuery(
      {
        url: 'account/me',
        method: 'GET',
      },
      api,
      extraOptions
    );

    if (!!error) {
      api.dispatch(logout());
      return response;
    } else {
      !!data && api.dispatch(update(data));
      return baseQuery(args, api, extraOptions);
    }
  } else if (response?.error && response?.error?.status !== 401) {
    console.error(response.error)
  }
  return response;
};

export const api = createApi({
  reducerPath: 'api',
  baseQuery: AuthQuery,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: 30,
  keepUnusedDataFor: 30,
  endpoints: () => ({}),
});
